import React from 'react';
import { connectWithStore, Spinner } from '../../utils'
import { store } from '../../store'

import {SvgEdit, SvgExitFill, SvgPlay} from '../svg'
import { openModal } from '../../api/modals/actions';
import { fetchSongbooks } from '../../api/songbooks/actions'

let trans = [
    gettext("Play a songbook"),
]

class PlaySongbookList extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            songbookListOpen: false,
            songbooks: [],
        }
    }


    componentDidMount(){
        // Close menu on outside click
        $(document).click((e) => {
            if(this.state.songbookListOpen && !($.contains($('.songbook-play-button')[0], e.target))) {
                this.setState({
                    songbookListOpen: false,
                    newSongBookOpen: false,
                })
            }
        })

        this.props.dispatch(fetchSongbooks(false))
    }

    // componentDidUpdate(prevProps){
    //   // Was fetching but not anymore
    //   let prevId = prevProps.collectionRelation.data.songbook
    //   if(prevId in this.state.songbookClicked){
    //     if (prevProps.songbooks.isFetching && this.props.songbooks.isFetching === false){
    //       this.setState({ songbookClicked: {...this.state.songbookClicked, [prevId]: false } }) //simple value
    //     }
    //   }
    // }

    toggleSongbookList(){
        var currentState = this.state.songbookListOpen;
        if (currentState && this.props.multipleSongs) {
            this.props.clearCheckedSongs();
        }
        this.setState({songbookListOpen: !currentState} , () => {
            actionItemOpen();
        });
    }

    hideSearchResults(){
        var container = $(".search-results");
        container.hide();
    }

    renderSongbooks(songbooks) {
        let songIds = this.props.ids;
        let allUserSongbooks = 
        <ul>
            {songbooks.map((songbook) => {
                return <li key={songbook.id} >
                    <div className='d-flex justify-content-between w-100 align-items-center songbook-list'>
                        <div className='songbook-title' >{songbook.title}</div>
                        <div>
                            <a href={`/songbooks/${songbook.id}/`} className='edit'>
                                <SvgEdit />
                            </a>
                            <a href={`/songbooks/${songbook.id}/play/`} className='play'>
                                <SvgPlay />
                            </a>
                        </div>
                    </div>
                </li>
            })}
        </ul>
        return allUserSongbooks;
    }


    showMessage() {
        this.props.dispatch(openModal("modal-paywall", "play-songbook"))
    }

    render() {
        let {songbookListOpen} = this.state;
        const { songbooks } = this.props
        
        return (
            <div className={`song-add-to-songbook-container songbook-play-button ${songbookListOpen ? " songbook-open" : ""} ${this.state.newSongBookOpen ? " new-songbook-open" : ""}`} disabled={this.props.disabled}>
                <div className={`song-add-to-songbook ${songbookListOpen ? " open" : ""} ${!this.props.user.isAuthenticated && "disabled"}`}>
                    <div className="inner-container">
                        <button className="btn btn-outline btn-icon-after" onClick={this.props.user.isAuthenticated ? this.toggleSongbookList.bind(this) : this.showMessage.bind(this)}><span className="add">{gettext("Songbooks")}</span> {songbookListOpen ? <SvgExitFill/> : <div className="svg-container play-icon"><SvgPlay/></div>}</button>
                        <div className="songbooks">
                            {songbooks && songbooks.privateSongbooks && songbooks.privateSongbooks.results && this.renderSongbooks(songbooks.privateSongbooks.results)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    var f = {
        user: {},
        songbooks: {},
        collectionRelation: {}
    }
    f.user = (state.user === undefined) ? [] : state.user
    f.songbooks = (state.songbooks === undefined) ? [] : state.songbooks
    f.collectionRelation = (state.collectionRelation === undefined) ? [] : state.collectionRelation
    return f;
}

// export default connect(mapStateToProps)(Song);
export default connectWithStore(store, PlaySongbookList, mapStateToProps);
